import React from 'react';
import {Col, Container, Row} from 'reactstrap';
import classNames from 'classnames';
import './Guarantee.scss';
import IconList, {IconListItem} from 'components/Elements/IconList';

export default function Guarantee({bgColor = 'white', borderColor = 'gray', ...props}) {
  return (
    <div
      className={classNames(
        `guarantee-box rounded background-${bgColor} border-1 border-solid border-${borderColor} box-shadow-black-50 ${props.className}`
      )}
    >
      <h2 className="guarantee-heading text-center text-md-left">
        All With Our 60-Day Total <br className="d-none d-md-block" />
        Risk-Free Money-Back Guarantee
      </h2>
      <p>Take up to 60 days to soak up the entire Impact Kit.</p>
      <p>We guarantee that you and your family will:</p>
      <IconList>
        <IconListItem>Love the health benefits of nutrient-packed foods</IconListItem>
        <IconListItem>Discover how to savor delicious home-grown food in any location (easily!)</IconListItem>
        <IconListItem>Enjoy the satisfaction of building a better future for life on Earth</IconListItem>
      </IconList>
      <p>
        Your satisfaction is important to us so if for any reason you aren’t 100% happy with your purchase, you have 60
        days to request a prompt and total refund.
      </p>
      <p>
        Just email us at <a href="mailto:support@foodrevolution.org">support@foodrevolution.org</a> or call us at{' '}
        <a href="tel:(831) 824-4779">(831) 824-4779</a>.
      </p>
      <p className="mb-0">
        If you request a refund for any reason, anything that you've already downloaded from the Impact Kit is yours to
        keep.
      </p>
    </div>
  );
}
